import React, { FunctionComponent, ReactNode } from "react";

import {
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";

interface ComboCampaignNoCombinationsSelectProps
  extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: number) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: number;
}

export const ComboCampaignNoCombinationsSelect: FunctionComponent<
  ComboCampaignNoCombinationsSelectProps
> = ({
  label = "Number of combinations",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  ...props
}) => {
  const combinationsData = [1, 2, 3, 4, 5];

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      onSelected(event.target.value as number);
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  const rnd = Math.floor(Math.random() * 100 + 1);
  const id = `combo-select-${rnd}`;

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={props.error}
      style={props.style}
    >
      <InputLabel
        id={`${id}-label`}
        style={
          variant === "outlined"
            ? {
                position: "relative",
                maxWidth: "100%",
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value ?? "2"}
        onChange={handleChange}
        labelId={`${id}-label`}
        id={id}
        input={<Input />}
        disabled={props.disabled}
      >
        {combinationsData.map(item => (
          <MenuItem key={`${rnd}-${item}`} value={item}>
            <ListItemText primary={`${item} products`} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
